import { createRoute } from '@tanstack/react-router';

import { RootRoute } from '$/routes/RootRoute';

export const PrivacyRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/privacy',
}).lazy(() => import('./PrivacyRoute.lazy').then((d) => d.LazyPrivacyRoute));
